import React, { useEffect, useState } from "react";
import lookupService from "../services/lookupService";

const POTermsConditionsDrawer = ({
  terms,
  setTerms,
  onClose
}) => {

  const [masterTerms, setMasterTerms] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    loadTerms();

  }, []);

  const loadTerms = async () => {

    try {

      setLoading(true);

      const data =
        await lookupService.getTermsConditions();

      setMasterTerms(data || []);

    } catch (e) {

      console.error(
        "Failed to load terms",
        e
      );

    } finally {

      setLoading(false);
    }
  };

  const updateTermValue = (
    term,
    value
  ) => {

    const existing = terms.find(
      t => t.term_master_id === term.id
    );

    if (existing) {

      setTerms(
        terms.map(t =>
          t.term_master_id === term.id
            ? {
                ...t,
                value
              }
            : t
        )
      );

    } else {

      setTerms([
        ...terms,
        {
          term_master_id: term.id,
          value
        }
      ]);
    }
  };

  const renderField = (
    term,
    value
  ) => {

    switch (term.field_type) {

      case "TEXT":

        return (
          <input
            className="form-control"
            value={value}
            placeholder={
              term.placeholder_text || ""
            }
            onChange={(e) =>
              updateTermValue(
                term,
                e.target.value
              )
            }
          />
        );

      case "TEXTAREA":

        return (
          <textarea
            className="form-control"
            rows={3}
            value={value}
            placeholder={
              term.placeholder_text || ""
            }
            onChange={(e) =>
              updateTermValue(
                term,
                e.target.value
              )
            }
          />
        );

      case "NUMBER":

        return (
          <input
            type="number"
            className="form-control"
            value={value}
            placeholder={
              term.placeholder_text || ""
            }
            onChange={(e) =>
              updateTermValue(
                term,
                e.target.value
              )
            }
          />
        );

      case "DATE":

        return (
          <input
            type="date"
            className="form-control"
            value={value}
            onChange={(e) =>
              updateTermValue(
                term,
                e.target.value
              )
            }
          />
        );

      case "YES_NO":

        return (
          <select
            className="form-select"
            value={value}
            onChange={(e) =>
              updateTermValue(
                term,
                e.target.value
              )
            }
          >
            <option value="">
              Select
            </option>

            <option value="YES">
              Yes
            </option>

            <option value="NO">
              No
            </option>

          </select>
        );

      case "DROPDOWN":

        return (
          <select
            className="form-select"
            value={value}
            onChange={(e) =>
              updateTermValue(
                term,
                e.target.value
              )
            }
          >
            <option value="">
              Select
            </option>

            {term.options.map(o => (
              <option
                key={o.id}
                value={o.option_code}
              >
                {o.option_label}
              </option>
            ))}
          </select>
        );

      default:

        return null;
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.4)",
          zIndex: 10000
        }}
        onClick={onClose}
      />

      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "600px",
          height: "100%",
          background: "#fff",
          zIndex: 10001,
          overflowY: "auto",
          boxShadow: "-4px 0 12px rgba(0,0,0,0.1)"
        }}
      >

        <div
          style={{
            background: "#4f46e5",
            color: "#fff",
            padding: "14px 16px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <h5 style={{ margin: 0 }}>
            Terms & Conditions
          </h5>

          <button
            onClick={onClose}
            style={{
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: 20,
              cursor: "pointer"
            }}
          >
            ×
          </button>
        </div>

        <div style={{ padding: 16 }}>

          {loading ? (

            <div className="alert alert-info">
              Loading Terms...
            </div>

          ) : (

            <div className="row">

              {masterTerms.map(term => {

                const existingValue =
                  terms.find(
                    t => t.term_master_id === term.id
                  )?.value || "";

                return (

                  <div
                    key={term.id}
                    className="col-md-12 mb-3"
                  >

                    <label className="form-label">

                      {term.term_name}

                      {term.is_mandatory && (
                        <span className="text-danger">
                          {" "}*
                        </span>
                      )}

                    </label>

                    {renderField(
                      term,
                      existingValue
                    )}

                  </div>

                );

              })}

            </div>

          )}

        </div>

      </div>
    </>
  );
};

export default POTermsConditionsDrawer;